import React, { FunctionComponent, useLayoutEffect, useState } from "react";
import "./style.scss";
import circle_img from "../../asserts/svg/circle.svg";
import square_img from "../../asserts/svg/square.svg";
import triangle_img from "../../asserts/svg/triangle.svg";
import { NavLink, useNavigate } from "react-router-dom";

const mobileWidth = 680;

const BottomMenu: FunctionComponent = () => {
    const navigate = useNavigate();

    const [isMobile, setIsMobile] = useState(window.innerWidth <= mobileWidth);

    useLayoutEffect(() => {
        window.addEventListener("resize", resize);  
        
        setTimeout(() => {
            resize();        
        }, 100);

        setTimeout(() => {
            resize();        
        }, 1000);

        return () => {
            window.removeEventListener("resize", resize);
        }
    });

    const resize = () => {
        setIsMobile(window.innerWidth <= mobileWidth);
    }

    const goTo = (id: string) => {
        navigate("/");

        setTimeout(() => {
            const el = document.getElementById(id);
            if (el) {
                if (!isMobile)
                    el.scrollIntoView({behavior: 'smooth'});
                else {
                    const offset = -50;
                    const bodyRect = document.body.getBoundingClientRect().top;
                    const elementRect = el.getBoundingClientRect().top;
                    const elementPosition = elementRect - bodyRect;
                    const offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }
        }, 100);
    }

    return <div className="BottomMenu">
        <div className="column first">
            <img src={circle_img} alt="circle" />
            <ul>
                <li className="link" onClick={() => goTo("pricign")}>Messengers</li>
                <li className="link" onClick={() => goTo("features")}>Features</li>
                <li className="link" onClick={() => goTo("about")}>About</li>
            </ul>
        </div>
        <div className="column second">
            <img src={square_img} alt="square" />
            <ul>
                <li>
                    <NavLink to="changeLog">
                        Change log
                    </NavLink>
                </li>
                <li>
                    <NavLink to="termsAndConditions">
                        Terms and conditions
                    </NavLink>
                </li>
                <li>
                    <NavLink to="privacyPolicy">
                        Privacy policy
                    </NavLink>
                </li>
            </ul>
        </div>
        <div className="column third">
            <img src={triangle_img} alt="triangle" />
            <div className="block">
                <div className="row">Spark Agency FZE</div>
                <div className="row">License No: 18231</div>
                <div className="row mail">Email: <a href="mailto:hello@timinator.app">hello@timinator.app</a></div>
            </div>
        </div>
    </div>
}

export default BottomMenu;